// 📦 File: frontend/src/pages/Onboarding/Comp/VehicleInfo.jsx (integrated)
import React, { useEffect, useState } from "react";
import Classes from "../Profile.module.css";
import { AddIcon } from "../../../../../utils/Icons";
import { useSelector, useDispatch } from "react-redux";
import backend from "../../../../../api";
import { setUserData } from "../../../../../redux-store/auth/actions";

export default function VehicleInfo({ data, update, onBack, onFinish }) {
  const { user } = useSelector((s) => s.auth);
  const dispatch = useDispatch();

  const [local, setLocal] = useState(data);
  useEffect(() => setLocal(data), [data]);

  const persist = async (vehicles) => {
    try {
      const payload = {
        customerProfile: {
          ...(user.customerProfile || {}),
          vehicle: { vehicles },
        },
      };
      const { data } = await backend.put(`/api/user/${user._id}`, payload);
      await dispatch(setUserData({ ...user, ...data.data }));
    } catch (err) {
      console.error("Failed to persist vehicles", err);
    }
  };

  const setVehicles = async (vehicles) => {
    setLocal({ vehicles });
    update({ vehicles });
    await persist(vehicles);
  };

  const change = (idx, key, value) => {
    const newVehicles = local.vehicles.map((v, i) =>
      i === idx ? { ...v, [key]: value } : v
    );
    setVehicles(newVehicles);
  };

  const addVehicle = () =>
    setVehicles([...local.vehicles, { make: "", model: "", plate: "" }]);

  const removeVehicle = (idx) =>
    setVehicles(local.vehicles.filter((_, i) => i !== idx));

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // mark onboarded true when finishing onboarding
      const payload = {
        customerProfile: {
          ...(user.customerProfile || {}),
          vehicle: { vehicles: local.vehicles },
        },
        onboarded: true,
      };
      const { data } = await backend.put(`/api/user/${user._id}`, payload);
      await dispatch(setUserData({ ...user, ...data.data }));
      onFinish();
    } catch (err) {
      console.error("Failed to complete onboarding", err);
    }
  };

  return (
    <form className={Classes.infoCon} onSubmit={handleSubmit}>
      {local?.vehicles?.map((v, idx) => (
        <div key={idx} className={Classes.vehicleGroup}>
          {/* Vehicle Make */}
          <div className={Classes.flexColGroup}>
            <div className={Classes.flexCol1}>
              <h5 className={Classes.label}>Vehicle Make</h5>
              <input
                type="text"
                className={Classes.inputField}
                placeholder="Enter vehicle make"
                value={v.make}
                onChange={(e) => change(idx, "make", e.target.value)}
                required={idx === 0}
              />
            </div>
          </div>

          {/* Vehicle Model */}
          <div className={Classes.flexColGroup}>
            <div className={Classes.flexCol1}>
              <h5 className={Classes.label}>Vehicle Model</h5>
              <input
                type="text"
                className={Classes.inputField}
                placeholder="Enter vehicle model"
                value={v.model}
                onChange={(e) => change(idx, "model", e.target.value)}
                required={idx === 0}
              />
            </div>
          </div>

          {/* License Plate */}
          <div className={Classes.flexColGroup} style={{ margin: "0" }}>
            <div className={Classes.flexCol1}>
              <h5 className={Classes.label}>License Plate Number</h5>
              <input
                type="text"
                className={Classes.inputField}
                placeholder="Enter license plate number"
                value={v.plate}
                onChange={(e) => change(idx, "plate", e.target.value)}
                required={idx === 0}
              />
            </div>
          </div>

          {/* remove button for additional vehicles */}
          {idx > 0 && (
            <button
              type="button"
              className={Classes.addBtnLink}
              onClick={() => removeVehicle(idx)}
              aria-label="Remove vehicle"
              style={{ margin: "10px 0 0 0" }}
            >
              <h5> Remove this vehicle</h5>
            </button>
          )}
        </div>
      ))}

      {local?.vehicles?.length < 3 && (
        <div className={Classes.addRow}>
          <button type="button" className={Classes.addBtnLink} onClick={addVehicle}>
            <AddIcon height="18px" fill="var(--primary-color)" />
            <h5>Add Additional Vehicle(s)</h5>
          </button>
        </div>
      )}

   
        <button type="submit" className={Classes.saveBtn}><h5>Finish</h5></button>
    </form>
  );
}
